module.exports = __webpack_public_path__ + "1e09a80f36a9aabd81cd8135f64bd73c.svg";